import { render, staticRenderFns } from "./configObjectiveOptions.vue?vue&type=template&id=06cb4955&scoped=true"
import script from "./configObjectiveOptions.vue?vue&type=script&lang=js"
export * from "./configObjectiveOptions.vue?vue&type=script&lang=js"
import style0 from "./configObjectiveOptions.vue?vue&type=style&index=0&id=06cb4955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb4955",
  null
  
)

export default component.exports